export var MapType;
(function (MapType) {
    /** ROADMAP - Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** SATELITE - Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** HYBRID - Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** TERRAIN - Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
    MapType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MapType || (MapType = {}));
//# sourceMappingURL=plugin_map.enums.js.map